import type { ReactNode } from "react";
import { Navigate } from "react-router";
import type { StudioFeatureKey } from "@intelliextract-studio/shared";
import { useFeatures } from "@/hooks/useFeatures";

interface FeatureRouteGuardProps {
  feature: StudioFeatureKey;
  children: ReactNode;
}

export function FeatureRouteGuard({ feature, children }: Readonly<FeatureRouteGuardProps>) {
  const { hasFeature, firstAccessibleRoute } = useFeatures();

  if (hasFeature(feature)) {
    return children;
  }

  if (firstAccessibleRoute === "/access-denied") {
    return <Navigate to="/access-denied" replace />;
  }

  return <Navigate to={firstAccessibleRoute} replace />;
}
